const socials = {
  slug: 'f/socials',
  twitterAuthUrl: () => `${socials.slug}/twitter/oauth-url`,
  twitterRequestAccessToken: () => `${socials.slug}/twitter/access-token`,
  twitterGetUserDetails: () => `${socials.slug}/twitter/user-profile`
}

export default socials
